import { FaPlus } from "react-icons/fa6";
import { BtnDefault } from "../../../../components/buttons/BtnDefault";
import { Header } from "../../../../components/Header";
import { DashboardLayout } from "../../../../components/layouts/DashboardLayout";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { WaDeviceSection } from "./sections/WaDevice";
import { useHookWaDevice } from "../../../../hooks/useHookWaDevice";
import { WaDeviceTableSection } from "./sections/table";
import { WaDeviceCardSection } from "./sections/card/index.jsx";
import { AddNewDeviceModal } from "./sections/modal/create.jsx";
import { UpdateWaDeviceModal } from "./sections/modal/update.jsx";

export const WhatsAppNumberPage = () => {
    const [showSidebar, setShowSidebar] = useState(true);
    const navigate = useNavigate();

    // --- STATE MANAGEMENT ---
    const [activeModal, setActiveModal] = useState(null); // 'message' | 'addDevice' | null
    const [selectedDevice, setSelectedDevice] = useState(null);

    const [openAddDeviceModal, setOpenAddDeviceModal] = useState(false);
    const [openUpdateDeviceModal, setOpenUpdateDeviceModal] = useState(false);

    const [refreshHistory, setRefreshHistory] = useState(false);
    const [refreshWa, setRefreshWa] = useState(false);

    const { data, loading, refreshData } = useHookWaDevice();

    return (
        <>
            <Helmet>
                <title>Pesan WhatsApp - DANELA NET</title>
                <meta
                    name="description"
                    content="Kelola data whatsapp gateway, mengirim pesan broadcast dan private."
                />
            </Helmet>

            <DashboardLayout showSidebar={showSidebar} setShowSidebar={setShowSidebar}>
                {/* ===== Header ===== */}
                <Header toggleSidebar={() => setShowSidebar(!showSidebar)}>
                    <div className="flex items-center gap-3">
                        <h2 className="text-base md:text-xl font-bold text-gray-100">
                            No WhatsApp
                        </h2>
                    </div>

                    <BtnDefault onClick={() => setOpenAddDeviceModal(true)}>
                        <FaPlus className="text-xs hidden sm:block" />
                        <span>Tambah Device</span>
                    </BtnDefault>
                </Header>

                <main className="p-4 lg:p-6 space-y-5">
                    {/* <Desktop Section /> */}
                    <WaDeviceTableSection
                        data={data} loading={loading}
                        refreshData={refreshData}
                        selectedDevice={selectedDevice}
                        setSelectedDevice={setSelectedDevice}
                        openUpdateDeviceModal={openUpdateDeviceModal}
                        setOpenUpdateDeviceModal={setOpenUpdateDeviceModal}
                    />

                    {/* Mobile Section*/}
                    <WaDeviceCardSection
                        data={data}
                        loading={loading}
                        refreshData={refreshData}
                    />

                </main>

            </DashboardLayout>

            <AddNewDeviceModal
                openModal={openAddDeviceModal}
                setOpenModal={setOpenAddDeviceModal}
                refreshData={refreshData}
            />

            <UpdateWaDeviceModal
                openModal={openUpdateDeviceModal}
                setOpenModal={setOpenUpdateDeviceModal}
                refreshData={refreshData}
                selectedDevice={selectedDevice}
            />
        </>
    );
};